"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mxp_schemas_1 = require("mxp-schemas");
exports.default = (cartItem) => {
    const isProductNonStore = mxp_schemas_1.Product.ProductType.NON_STORE === cartItem.productDetails.productType;
    const isProductOnSite = mxp_schemas_1.Product.ProductType.ONSITE === cartItem.productDetails.productType;
    return isProductNonStore || isProductOnSite;
};
//# sourceMappingURL=isManualProduct.js.map